export class InvoiceItem {
  id: string;
  catalogItemId: string;
  invoiceId: string;
  name: string;
  description: string;
  quantity: number;
  unitPrice: number;
  total: number;

  constructor(m: Partial<InvoiceItem>) {
    this.id = m.id || '';
    this.invoiceId = m.invoiceId || '';
    this.name = m.name || '';
    this.description = m.description || '';
    this.quantity = m.quantity || 0;
    this.unitPrice = m.unitPrice || 0;
    this.total = m.total || 0;
    this.catalogItemId = m.catalogItemId || '';
  }

  static createEmpty(): InvoiceItem {
    return new InvoiceItem({
      id: '',
      invoiceId: '',
      catalogItemId: '',
      name: '',
      description: '',
      quantity: 0,
      unitPrice: 0,
      total: 0,
    });
  }
}
